import { __decorate } from "tslib";
import { Group, Vector3 } from 'three';
import { FemurAnalyzerAPConfig as Config } from '../../Config/FemurAnalyzerAPConfig.js';
import { Save, SaveChild } from '../../Core/Save.js';
import { ViewType } from '../../Models/AppModel.js';
import { Consts } from '../../Utils/Consts.js';
import { CalculationPoint } from '../Primitive/CalculationPoint.js';
import { DraggablePoint } from '../Primitive/DraggablePoint.js';
import { LabelAngle } from '../Primitive/Label/LabelAngle.js';
import { LinePointToPoint2 } from '../Primitive/LinePointToPoint2.js';
export class FemurAnalyzerAPAnatomical extends Group {
    constructor(isLeft, isContralateral, FH) {
        super();
        this.name = 'FemurAnalyzerAPAnatomical';
        this.add(this.NS_GT_PointForLineUpper = new CalculationPoint('NS_GT_PointForLineUpper'), this.NS_FH_A = new DraggablePoint('NS_FH_A', ViewType.AP, Config.NS_FH_A_color), this.NS_FH_B = new DraggablePoint('NS_FH_B', ViewType.AP, Config.NS_FH_B_color), this.NS_FH_C = new DraggablePoint('NS_FH_C', ViewType.AP, Config.NS_FH_C_color), this.NS_GT_lower_A = new DraggablePoint('NS_GT_Lower_A', ViewType.AP, Config.NS_GT_lower_A_color), this.NS_GT_lower_B = new DraggablePoint('NS_GT_Lower_B', ViewType.AP, Config.NS_GT_lower_B_color), this.NS_GT_lower_C = new DraggablePoint('NS_GT_Lower_C', ViewType.AP, Config.NS_GT_lower_C_color), this.NS_GT_upper_A = new DraggablePoint('NS_GT_Upper_A', ViewType.AP, Config.NS_GT_upper_A_color), this.NS_GT_upper_B = new DraggablePoint('NS_GT_Upper_B', ViewType.AP, Config.NS_GT_upper_B_color), this.NS_GT_upper_C = new DraggablePoint('NS_GT_Upper_C', ViewType.AP, Config.NS_GT_upper_C_color), this.NS_FH_PointForLine = new CalculationPoint('NS_FH_PointForLine'), this.MNSALabel = new LabelAngle({
            name: 'MNSALabel',
            arcA: this.NS_FH_C,
            arcB: this.NS_GT_lower_C,
            arcCenter: this.NS_FH_PointForLine,
            viewType: ViewType.AP,
            labelAnchor: new Vector3(isLeft ? -7 : 7, -3),
            labelParams: { backgroundColor: Config.MNSALabel_backgroundColor, fontColor: Config.MNSALabel_fontColor },
            labelErrorParams: { backgroundColor: 'rgba(255, 0, 0, 0.6)', fontColor: '#ffffff' },
            minAngle: Consts.paleyAngles.AP.MNSA.min,
            maxAngle: Consts.paleyAngles.AP.MNSA.max,
            textCallback: (angle) => `MNSA ${angle}°`
        }), this.NS_FH_line = new LinePointToPoint2('NS_FH_Line', ViewType.AP, Config.NS_FH_Line_color, this.NS_FH_A, this.NS_FH_B), this.NS_GT_lower_line = new LinePointToPoint2('NS_GT_Lower_Line', ViewType.AP, Config.NS_GT_lower_line_color, this.NS_GT_lower_A, this.NS_GT_lower_B), this.NS_GT_upper_line = new LinePointToPoint2('NS_GT_Upper_Line', ViewType.AP, Config.NS_GT_upper_line_color, this.NS_GT_upper_A, this.NS_GT_upper_B), this.anatomicalAxis = new LinePointToPoint2('AnatomicalAxis', ViewType.AP, Config.anatomicalAxis_color, this.NS_GT_PointForLineUpper, this.NS_GT_lower_C), this.neckShaftAxis = new LinePointToPoint2('NeckShaftAxis', ViewType.AP, Config.neckShaftAxis_color, this.NS_FH_PointForLine, FH));
    }
}
__decorate([
    Save('position')
], FemurAnalyzerAPAnatomical.prototype, "NS_FH_A", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPAnatomical.prototype, "NS_FH_B", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPAnatomical.prototype, "NS_GT_upper_A", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPAnatomical.prototype, "NS_GT_upper_B", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPAnatomical.prototype, "NS_GT_lower_A", void 0);
__decorate([
    Save('position')
], FemurAnalyzerAPAnatomical.prototype, "NS_GT_lower_B", void 0);
__decorate([
    SaveChild()
], FemurAnalyzerAPAnatomical.prototype, "MNSALabel", void 0);
//# sourceMappingURL=FemurAnalyzerAPAnatomical.js.map